export default __webpack_public_path__ + "static/media/ci-win-back.4843e2ef.svg";